import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useApi } from "../api";
import { AppHeader } from "../components/AppHeader";
import { FtxCompletedOrderListItem } from "../components/FtxCompletedOrderListItem";
import { Numeral } from "../components/Numeral";
import { ICargo } from "../interfaces";
export const FtxCompletedOrderPage = () => {
  const params = useParams()
  const api = useApi('SAI');
  const [subOrders, setSubOrders] = useState([])
  const [strategy, setStrategy] = useState(null)
  const [profit, setProfit] = useState(0)
  useEffect(() => {
    if (params.orderId && subOrders.length === 0) {
      api.getFtxCompletedSubOrders(params.orderId, (cargo: ICargo) => {
        if (cargo.returnCode === '000000') {
          setSubOrders(cargo.info)
        }
      })
    }
  }, [api, params.orderId, subOrders.length])

  useEffect(() => {
    if (subOrders.length > 0 && strategy === null) {
      api.getFtxStrategy(subOrders[0]['strategy'], (cargo: ICargo) => {
        if (cargo.returnCode === '000000') {
          setStrategy(cargo.info)
        }
      })
    }
  }, [api, strategy, subOrders])

  useEffect(() => {
    subOrders.forEach((order: any) => {
      if (order['orderId'] !== order['coverOrder'])
      setProfit(profit => profit + order['profit'])
    })
  }, [subOrders])

  return (
    <>
      <div className="content colorbk" style={{ backgroundImage: `url('https://ai.supercoin.network/img/bgr.jpg')`, backgroundSize: "100% 100%" }}>
        <AppHeader></AppHeader>
        <div className="loginbg" style={{ minHeight: "auto" }}>
          <div className="bg1 p-3 ml-4">
            <img src="https://ai.supercoin.network/img/coin/FTT.png" alt="" style={{ filter: 'drop-shadow(0px 0px 8px #fff)', width: '50px' }} />
          </div>
          <div className="text-white p-3">獲利：<Numeral value={profit} /></div>
        </div>
      </div>
      
      <div className="p-3 bg-white">
        {subOrders.map((order: any) => {
          return (
            <FtxCompletedOrderListItem
              key={order['idFtxOrder']}
              strategy={strategy}
              order={order}
            ></FtxCompletedOrderListItem>
          )
        })}
      </div>

      <div className='mb-20'></div>
    </>
  )
}